<div [ngClass]="{ 'menu-open': isMenuOpen(), 'menu-not-open': !isMenuOpen() }" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
    <div class="loading-message">{{ message }}</div>
  </div>
</div>
